import { render } from "./NavigationBarDropdown.vue?vue&type=template&id=157bba2f&scoped=true"
import script from "./NavigationBarDropdown.vue?vue&type=script&lang=js"
export * from "./NavigationBarDropdown.vue?vue&type=script&lang=js"

import "./NavigationBarDropdown.vue?vue&type=style&index=0&id=157bba2f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157bba2f"]])

export default __exports__